import { useGetMagazineTagListPageQuery } from '@/hooks/magazine/magazine.gql.impl';
import { GetMagazineTagListPageQuery } from '@/types/bff/gql-schema';
import { MagazineListItemDto, MagazineTagListVo, MagazineType } from '@/types/magazine';
import dayjs from 'dayjs';

export const parseMagazineTagList = (data?: GetMagazineTagListPageQuery): Array<MagazineTagListVo> => {
  const parseMagazineListItem = (magazine: MagazineListItemDto) => {
    return {
      ...magazine,
      magazinePid: magazine.magazinePid,
      date: `${dayjs(magazine.createdAt).format('YYYY.MM.DD')}`,
    };
  };

  if (data) {
    return data.tagMagazineCursorPage.elements.map((magazine) => {
      return parseMagazineListItem(magazine as MagazineListItemDto);
    });
  }
  return [];
};

const useGetFaqTagListPage = (size = 20, tagName: string) => {
  const { data: faqs, isLoading: faqsLoading } = useGetMagazineTagListPageQuery(
    {
      request: {
        size,
        tagName,
        contentType: MagazineType.FAQ,
      },
    },
    {
      select: (data) => parseMagazineTagList(data),
    }
  );

  return {
    faqs: faqs ?? [],
    faqsLoading,
  };
};
export default useGetFaqTagListPage;
